import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ISSUE: `${cleanedFilename(__filename)}-issue`,
  ASIDE_HEADER: `${cleanedFilename(__filename)}-aside-header`,
  INNER_CONTAINER: `${cleanedFilename(__filename)}-inner-container`,
};
